import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import uniqid from 'uniqid';
import eye from '../../../../img/eye.png'
import hiddenEye from '../../../../img/hidden-eye.png'
import BC365Service from "../../../../services/beautyclub365";
import { isRussianNumber } from "../../../../shared/validations";
import "./Input.css";

export default Input = (props) => {
	const {
		labelText,
		type,
		placeholder,
		required = false,
		errorText = '',
		notice = '',
		width = '400px',
		setValue,
		phoneValidation = false,
		activateButton,
		setPhoneFieldConfirmed,
		existsError,
		setExistsError,
		inputValue,
		fieldName,
	} = props;
	let waitingSecinds = 60;

	const [showPassword, setShowPassword] = useState(false);
	const [isRusPhone, setRusPhone] = useState(false);
	const [currentValue, setCurrentValue] = useState('');
	const [isWaitingCode, setIsWaitingCode] = useState(false);
	const [wantConfirmCode, setWantConfirmCode] = useState(false);
	const [currentCode, setCurrentCode] = useState('');
	const [phoneConfirmed, setPhoneConfirmed] = useState(false);
	const [invalidPhoneCode, setInvalidPhoneCode] = useState(false);
	const [canSendAgain, setCanSendAgain] = useState(true);
	const [timer, setTimer] = useState();
	const [seconds, setSeconds] = useState(waitingSecinds);
	const [timerInterval, setTimeInterval] = useState();
	const [visualValue, setVisualValue] = useState('');
	const [checked, setChecked] = useState(false);

	useEffect(() => {
		if (typeof inputValue !== 'undefined' && inputValue !== '') {
			setCurrentValue(inputValue);
			setValue(inputValue);
			setVisualValue(inputValue);
		}
	}, []);

	const eyeIcon = (showPassword) ? hiddenEye : eye;
	const actionPassword = () => {
		setShowPassword(!showPassword);
	};
	const typeField = (showPassword) ? 'text' : type;

	const id = uniqid();
	const isPassword = type === 'password';
	const existsNotice = notice !== '';

	const updateValue = (e) => {
		const value = e.target.value;
		if (type === 'checkbox') {
			const isChecked = e.target.checked;
			setChecked(isChecked);
			setValue && setValue(isChecked);
		} else {
			setVisualValue(value);
			setCurrentValue(value);
			setValue && setValue(value);
			if (required && !value) {
				setExistsError && setExistsError(true);
			} else {
				setExistsError && setExistsError(false);
			}
		}

		if (phoneValidation) {
			const isRus = isRussianNumber(value);
			setRusPhone(isRus);
			if (phoneConfirmed) {
				setPhoneConfirmed(false);
				setPhoneFieldConfirmed(false);
				setIsWaitingCode(false);
				setCanSendAgain(true);
				setWantConfirmCode(false);
				setCurrentCode('');
			}
			activateButton && activateButton(!isRus);
		}
	};

	const updatePhoneCode = (e) => {
		const code = e.target.value;
		setCurrentCode(code);
		if (code !== '') {
			setWantConfirmCode(true);
		} else {
			setWantConfirmCode(false);
		}
	};

	const confirmPhone = useCallback(() => {
		const db = new BC365Service();
		db.confirmCode(currentValue.replace(/\D/g, ''), currentCode).then((answer) => {
			if (answer['is_valid']) {
				setPhoneConfirmed(true);
				setInvalidPhoneCode(false);
				clearTimeout(timer);
				clearInterval(timerInterval);
				activateButton(true);
				setPhoneFieldConfirmed(true);
			} else {
				setInvalidPhoneCode(true);
			}
		});
	}, [
		isRusPhone,
		setIsWaitingCode,
		isWaitingCode,
		currentValue,
		currentCode,
		setInvalidPhoneCode,
		invalidPhoneCode,
		activateButton,
	]);

	const sendCode = useCallback(() => {
		const db = new BC365Service();
		db.sendCode(currentValue.replace(/\D/g, '')).then((answer) => {
			setSeconds(60);
			setIsWaitingCode(true);
			setCanSendAgain(false);

			const interval = setInterval(() => {
				setSeconds(waitingSecinds--);
				if (waitingSecinds < 1) {
					clearInterval(interval);
				}
			}, 1000);

			const timer = setTimeout(() => {
				setCanSendAgain(true);
				clearTimeout(timer);
				clearInterval(timerInterval);
			}, 60000);

			setTimer(timer);
			setTimeInterval(interval);
		});
	}, [
		isRusPhone,
		setIsWaitingCode,
		isWaitingCode,
		currentValue,
		setTimer,
		setTimeInterval,
	]);

	return (
		<div className="inputWrapper" >
			{type !== 'checkbox' && (
				<label htmlFor={'input-' + id} className="inputLabel">
					{labelText}
					{required && <span className="inpurRequired">*</span>}
				</label>
			)}

			{type === 'checkbox' ? (
				<>
					<div className="checkboxWrapper">
						<input
							type="checkbox"
							id={'input-' + id}
							name={fieldName ?? null}
							checked={checked}
							onChange={updateValue}
						/>
						<label htmlFor={'input-' + id}>{labelText}</label>
						{existsNotice && <span className="inputNotice">{notice}</span>}
					</div>
					{existsError && errorText && <span className="inputError">{errorText}</span>}
				</>
			) : (<>{isPassword &&
				<div className="eyeWrapper" style={{ width }}>
					<input
						type={typeField}
						placeholder={placeholder}
						id={'input-' + id}
						className={(existsError && errorText !== '') ? "inputText inputFieldError" : "inputText"}
						style={{ width }}
						onChange={updateValue}
						value={visualValue ?? null}
						name={fieldName ?? null}
					/>
					<span className="inpurEye">
						<img src={eyeIcon} onClick={actionPassword} />
					</span>
					{(existsError && errorText !== '') && <span className="inputError" style={{ width: width }}>{errorText}</span>}
					{existsNotice && <span className="inputNotice">{notice}</span>}
				</div>
			}
				{!isPassword &&
					<div className="eyeWrapper" style={{ width }}>
						<input
							type={type}
							placeholder={placeholder}
							id={'input-' + id}
							className={(existsError && errorText !== '') ? "inputText inputFieldError" : "inputText"}
							style={{ width }}
							onChange={updateValue}
							value={visualValue ?? null}
							name={fieldName ?? null}
						/>
						{
							phoneValidation && isRusPhone && isWaitingCode && !phoneConfirmed &&
							<input
								type="text"
								placeholder="Введите код"
								id={'input-code-' + id}
								className={invalidPhoneCode ? "inputText inputFieldError" : "inputText"}
								style={{ width }}
								onChange={updatePhoneCode}
							/>
						}
						{invalidPhoneCode && !phoneConfirmed && <span className="inputErrorCode">Введённый код неправильный</span>}
						{
							phoneValidation && isRusPhone && canSendAgain && !wantConfirmCode && !phoneConfirmed &&
							<span className="phoneConfirmButton" onClick={sendCode} style={{ width }}>Выслать код подтверждения</span>
						}
						{
							phoneValidation && isRusPhone && !canSendAgain && !wantConfirmCode && !phoneConfirmed &&
							<>
								<span className="phoneWaitnigNext" style={{ width }}>Код отправлен</span>
								<span className="phoneWaitnigNextText">На указанный номер телефона был выслан код подтверждения. Повторная отправка через {seconds} сек.</span>
							</>
						}
						{
							phoneValidation && isRusPhone && wantConfirmCode && !phoneConfirmed &&
							<span className="readyConfirmPhone" onClick={confirmPhone} style={{ width }}>Подтвердить телефон</span>
						}
						{
							phoneValidation && isRusPhone && phoneConfirmed &&
							<span className="confirmedPhone" onClick={confirmPhone} style={{ width }}>Телефон успешно подтверждён</span>
						}
						{(existsError && errorText !== '') && <span className="inputError">{errorText}</span>}
						{existsNotice && <span className="inputNotice">{notice}</span>}
					</div>
				}</>)}
		</div>
	);
}
